import { render, staticRenderFns } from "./cover-field-vertical.vue?vue&type=template&id=8d547c62&scoped=true"
import script from "./cover-field-vertical.vue?vue&type=script&lang=js"
export * from "./cover-field-vertical.vue?vue&type=script&lang=js"
import style0 from "./cover-field-vertical.vue?vue&type=style&index=0&id=8d547c62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d547c62",
  null
  
)

export default component.exports